<template>
    <!-- 产品与服务 -->
    <div>
        <div class="swiper-slide" v-for="(value, index) in components" :key="index">
            <component :is="value" />
        </div>
    </div>
</template>
<script>
// import Swiper from 'swiper';
import Product from './Product.vue';
import Network from './Network.vue';
import Cost from './Cost.vue';
import Bill from './Bill.vue';
import Currency from './Currency.vue';
import Settlement from './Settlement.vue';
import Exchange from './Exchange.vue';
import Plan from './Plan.vue';
import Enterprise from './Enterprise.vue';
import Account from './Account.vue';
import Security from './Security.vue';
import Organization from './Organization.vue';
import Fund from './Fund.vue';

import AppFooter from '@/layout/AppFooter.vue';

export default {
    name: 'productAll',
    components: {
        Product,
        Network,
        Cost,
        Bill,
        Currency,
        Settlement,
        Exchange,
        Plan,
        Enterprise,
        Account,
        Security,
        Organization,
        Fund,
        AppFooter
    },
    data() {
        return {
            mySwiper: null,
            components: [
                'Product',
                'Network',
                'Cost',
                'Bill',
                'Currency',
                'Settlement',
                'Exchange',
                'Plan',
                'Enterprise',
                'Account',
                'Security',
                'Organization',
                'Fund',
                'AppFooter'
            ]
        };
    },
    mounted() {
        // this.initSwiper();
        // if (this.$route.params.id !== '0') {
        //     if (this.mySwiper) {
        //         this.mySwiper.slideTo(this.$route.params.id, 500); // 500为动画时长，可自定义
        //     }
        // }
    },
    beforeDestroy() {
        // if (this.mySwiper) {
        //     this.mySwiper.destroy();
        // }
    },
    created() {
    },
    methods: {
        initSwiper() {
            this.mySwiper = new Swiper(this.$refs.mySwiper, {
                direction: 'vertical',
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                speed: 500,
                mousewheel: true,
                simulateTouch: false,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                },
                on: {
                    slideChange: function () {
                        console.log('当前滑动到第' + (this.activeIndex + 1) + '屏');
                    },
                }
            });
        },
    },
}
</script>
<style scoped lang="scss">
.egg-container {
    width: 100%;
    height: var(--main-height);
    overflow: hidden;
}

.swiper-container {
    width: 100%;
    height: var(--main-height);
}

.swiper-slide {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // text-align: center;
    // font-size: 18px;
    // background: #fff;
    // color: #fff;
    position: relative;
}


/* 分页器样式 */
.swiper-pagination {
    width: 20px;
    overflow: hidden;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;

    ::v-deep .swiper-pagination-bullet {
        width: 20px;
        height: 5px;
        border-radius: 10px;
    }
}

// .swiper-pagination-bullet {
//     width: 30px;
//     height: 12px;
//     background: rgba(255, 255, 255, 0.5);
//     margin: 8px 0;
//     border-radius: 50%;
//     cursor: pointer;
//     transition: all 0.3s ease;
// }

// .swiper-pagination-bullet-active {
//     background: #fff;
//     transform: scale(1.3);
// }

/* 响应式设计 */
@media (max-width: 768px) {
    .slide-content h1 {
        font-size: 36px;
    }

    .slide-content p {
        font-size: 18px;
    }
}
</style>